// ============================================
// EDIT THIS FILE TO CUSTOMIZE YOUR PORTFOLIO
// ============================================

export const personalInfo = {
  name: "Marcos Vallejo",
  title: "Technical Operations · Computer Repair · IT Support · Web & Creative Systems",
  tagline: "Hands-on technical work across hardware, software, and digital systems — with a creative edge.",
  email: "thisismarcos@gmail.com",
  profileImage: "/images/profile.jpg",
  resumeLink: "/resume.pdf",
};

export const socialLinks = {
  github: "https://github.com/MarcosV6",
  linkedin: "https://www.linkedin.com/in/marcosv6/",
  twitter: "https://x.com/TheRealMarcosV",
};

export const emailjsConfig = {
  serviceId: "YOUR_SERVICE_ID",
  templateId: "YOUR_TEMPLATE_ID",
  publicKey: "YOUR_PUBLIC_KEY",
};

export const about = {
  bio: `Technical and operations-focused professional with experience spanning computer repair, IT support, web and e-commerce management, and creative execution. Comfortable working across hardware, software, troubleshooting, digital systems, and fast-paced business environments. Hands-on, adaptable approach to solving problems and supporting both technical and operational needs.`,

  stats: [
    { value: "10+", label: "Years Experience" },
    { value: "4", label: "Industries" },
    { value: "20+", label: "Technologies" },
  ],

  skills: [
    "Hardware Diagnostics & Repair",
    "OS Installation & Configuration",
    "Software Troubleshooting",
    "Device Configuration",
    "HTML, CSS & JavaScript",
    "React",
    "Shopify & WordPress",
    "Adobe Creative Suite",
    "Final Cut Pro",
    "Branding & Creative Direction",
    "VS Code & CLI (Bash/Zsh)",
    "QuickBooks & Excel",
    "Rust",
    "Solidity",
  ],
};

export const projects = [
  {
    id: 1,
    title: "OpenClaw Dashboard",
    description: "A self-hosted dashboard for managing AI agent workflows — chat, task management, usage tracking, research archives, and monitoring in one interface.",
    image: "/images/project1.jpg",
    tags: ["TypeScript", "JavaScript", "CSS"],
    liveLink: "https://github.com/MarcosV6/openclaw-dashboard",
    githubLink: "https://github.com/MarcosV6/openclaw-dashboard",
  },
  {
    id: 2,
    title: "codemaxxing",
    description: "An open-source terminal coding agent that works with local and remote LLM providers. Built for developer workflow, model flexibility, and practical usability.",
    image: "/images/project2.jpg",
    tags: ["CLI", "AI", "Developer Tools"],
    liveLink: "https://github.com/MarcosV6/codemaxxing",
    githubLink: "https://github.com/MarcosV6/codemaxxing",
  },
  {
    id: 3,
    title: "Portfolio Website",
    description: "A responsive portfolio built with React — clean design, smooth interactions, and fast performance.",
    image: "/images/project3.jpg",
    tags: ["React", "JavaScript", "CSS"],
    liveLink: "https://marcos-portfolio-azure.vercel.app/",
    githubLink: "https://github.com/MarcosV6/Final-Portfolio-MV",
  },
];

export const experience = [
  {
    id: 1,
    company: "203 Trading LLC — Norwalk, CT",
    role: "Computer Technician",
    period: "Apr 2023 – Present",
    description: "Diagnose, configure, repair, and prepare laptops, desktops, and other devices in a fast-paced refurbishment environment. Handle hardware repairs, OS installs, software troubleshooting, and customer-facing repair workflows across a wide range of devices.",
  },
  {
    id: 2,
    company: "Evolution United States — Fairfield, CT",
    role: "Live Dealer",
    period: "Aug 2022 – Apr 2023",
    description: "Delivered live table games in a customer-facing gaming environment. Managed game flow on camera, followed strict operational standards, and maintained speed and consistency under pressure.",
  },
  {
    id: 3,
    company: "VSL Fighting — Stamford, CT",
    role: "Creative Manager",
    period: "Jul 2016 – Nov 2021",
    description: "Contributed to rebranding efforts including website redesign, product design, and marketing visuals. Managed e-commerce on Shopify and WordPress, and maintained brand presence across social platforms.",
  },
  {
    id: 4,
    company: "View Entertainment — Stamford, CT",
    role: "IT Manager",
    period: "Jul 2013 – Jul 2020",
    description: "Primary help-desk contact — diagnosed and resolved technical issues across email, network, telecom, and equipment. Performed server maintenance, trained end users, and supported administrative workflows.",
  },
];
